const w$1 = typeof window !== "undefined" ? window : void 0;
const rule = (url) => {
  return {
    isDev: isDev(url),
    isProd: isProd(url),
    isB2B: isB2B(url),
    isB2C: isB2C(url),
    isPublic: isPublic(url),
    isPrivate: isPrivate(url),
    pathEndsWith: (segments) => endsWith(segments, url),
    pathStartsWith: (segments) => startsWith(segments, url),
    pathIncludes: (segments) => includes(segments, url),
    pathMatches: (regexps) => matches(regexps, url),
    pathMatchesExact: (strings) => matchesExact(strings, url)
  };
};
const isDev = (url) => {
  return url.host !== "www.telia.se" && url.host !== "telia.se" || typeof w$1?.ENVIRONMENT !== "undefined" && w$1?.ENVIRONMENT === "legacy-dev";
};
const isProd = (url) => url.hostname === "www.telia.se" || url.hostname === "telia.se";
const isB2B = (url) => url.pathname?.startsWith("/foretag");
const isB2C = (url) => !isB2B(url);
const isPublic = (url) => !startsWith(
  ["/privat/mitt-telia", "/mitt-telia", "/foretag/mybusiness", "/foretag/telia-at-work"],
  url
);
const isPrivate = (url) => !isPublic(url);
const startsWith = (segment, url) => segment.some((pathname) => url.pathname.startsWith(pathname));
const endsWith = (segment, url) => segment.some((pathname) => url.pathname.endsWith(pathname));
const includes = (segment, url) => segment.some((pathname) => url.pathname.includes(pathname));
const matches = (regexps, url) => regexps.some((pattern) => pattern.test(url.pathname));
const matchesExact = (strings, url) => strings.some((str) => str === url.pathname);

const w = typeof window !== "undefined" ? window : void 0;
const toggles = {
  ["analytics-log" /* ANALYTICS_LOG */]: false
};
const isEnabled = (feature) => w ? typeof toggles[feature] !== "undefined" && !!localStorage.getItem(`ft-${feature}`) : false;
const logEnabled = () => isEnabled("analytics-log" /* ANALYTICS_LOG */);
const snakeCase = (str) => str.toLocaleLowerCase().replace(/ /g, "_");
const convertToSnakeCase = (obj) => {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map((item) => convertToSnakeCase(item));
  }
  const snakeCaseObj = {};
  for (const key in obj) {
    if (typeof obj[key] === "string") {
      snakeCaseObj[key] = snakeCase(obj[key]);
    } else {
      snakeCaseObj[key] = convertToSnakeCase(obj[key]);
    }
  }
  return snakeCaseObj;
};

const track = (eventName, eventParams) => {
  if (!w) {
    return;
  }
  const eventObject = {
    event: eventName,
    ...convertToSnakeCase(eventParams)
  };
  if (logEnabled()) {
    console.table(eventObject);
  }
  w.dataLayer = w?.dataLayer || [];
  w.dataLayer.push(eventObject);
};
const getDefaultEventParameters = (url) => ({
  page_type: getPageType(url),
  page_segment: getPagesegment(url),
  business_area: getBusinessArea(url)
});
const getBusinessArea = (url) => {
  return url.pathname.startsWith("/foretag") ? "b2b" : "b2c";
};
const getPageType = (url) => {
  const r = rule(url);
  const pageType = "unknown";
  if (r.pathMatches([/^\/foretag\/mybusiness\/\d{9}\/?$/]) || r.pathMatchesExact(["/", "/foretag"])) {
    return "start";
  }
  if (r.pathMatches([/^\/foretag\/mybusiness\/\d{9}\/bestall/]) || r.pathMatches([
    /^\/foretag\/bredband\/(?:anpassa|bekraftelse|bestall|kassa|organisationsval|till-kassan)/
  ])) {
    return "order";
  }
  if (r.pathMatches([/^\/foretag\/mybusiness\/\d{9}\/hantera/])) {
    return "manage";
  }
  if (r.pathMatches([/^\/foretag\/mybusiness\/\d{9}\/fakturor/])) {
    return "invoices";
  }
  if (r.pathMatches([/^\/foretag\/mybusiness\/\d{9}\/support/])) {
    return "support";
  }
  if (r.pathMatches([/^\/foretag\/mybusiness\/\d{9}\/installningar\/foretag/])) {
    return "settings";
  }
  if (r.pathMatches([/^\/foretag\/mybusiness\/\d{9}\/release-notes/])) {
    return "article";
  }
  if (r.pathStartsWith(["/sok", "/foretag/sok"])) {
    return "search";
  }
  if (r.pathStartsWith(["/formular", "/foretag/formular"])) {
    return "form";
  }
  if (r.pathMatches([/^\/foretag\/telia-at-work\/support/])) {
    return "support";
  }
  if (r.pathMatches([/^\/foretag\/telia-at-work/])) {
    return "subscription";
  }
  if (r.pathStartsWith(["/foretag/support"])) {
    return "support";
  }
  if (r.pathStartsWith(["/foretag/mer-fran-telia"])) {
    return "about";
  }
  return pageType;
};
const getPagesegment = (url) => {
  const r = rule(url);
  let pageSegment = "open_pages";
  if (typeof url.pathname === "undefined") {
    return "";
  }
  if (r.pathStartsWith(["/foretag/mybusiness"])) {
    pageSegment = "mybusiness";
  } else if (r.pathStartsWith(["/mitt-telia", "/privat/mitt-telia"])) {
    pageSegment = "mitt_telia_web";
  } else if (r.pathStartsWith(["/support", "/foretag/support", "/kontakt"])) {
    pageSegment = "open_pages_support";
  } else if (r.pathStartsWith(["/foretag/telia-at-work"])) {
    pageSegment = "telia_at_work";
  }
  return pageSegment;
};

export { getDefaultEventParameters, track };
//# sourceMappingURL=b2x-google-analytics.esm.js.map
